import { AI_PLAYGROUND_CONSTANTS } from "../AIPlayground.constants";

const { ERROR_COLORS } = AI_PLAYGROUND_CONSTANTS;

// Centralized styling constants for error displays
export const ERROR_STYLES = {
  container: {
    padding: "20px",
    backgroundColor: ERROR_COLORS.background,
    border: `1px solid ${ERROR_COLORS.border}`,
    borderRadius: "8px",
    color: ERROR_COLORS.text,
    borderLeft: `4px solid ${ERROR_COLORS.borderAccent}`
  } as const,

  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    fontWeight: "600",
    fontSize: "16px"
  } as const,

  icon: {
    marginRight: "10px",
    fontSize: "18px",
    color: ERROR_COLORS.borderAccent
  } as const,

  message: {
    fontSize: "14px",
    lineHeight: "1.6",
    marginBottom: "16px"
  } as const,

  troubleshooting: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: ERROR_COLORS.troubleshootingBackground,
    borderRadius: "4px",
    fontSize: "12px",
    color: ERROR_COLORS.troubleshootingText
  } as const,

  list: {
    margin: "8px 0 0 16px",
    padding: 0
  } as const
} as const;

export const ERROR_BUTTON_STYLES = {
  secondary: {
    root: {
      borderColor: ERROR_COLORS.buttonPrimary,
      color: ERROR_COLORS.buttonPrimary,
      minWidth: "140px",
      marginTop: "16px"
    },
    rootHovered: {
      borderColor: ERROR_COLORS.buttonPrimaryHover,
      color: ERROR_COLORS.buttonPrimaryHover
    }
  }
} as const;
